import { render } from "./PlansTable.vue?vue&type=template&id=d9b7c08c&scoped=true&ts=true"
import script from "./PlansTable.vue?vue&type=script&lang=ts"
export * from "./PlansTable.vue?vue&type=script&lang=ts"

import "./PlansTable.vue?vue&type=style&index=0&id=d9b7c08c&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b7c08c"]])

export default __exports__